import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DEPARTMENT_TYPES;

export var VEHICLE_SALES = {
  id: 'VEHICLE_SALES',
  name: __('Vehicle Sales')
};
export var SERVICE = {
  id: 'SERVICE',
  name: __('Service')
};
export var PARTS = {
  id: 'PARTS',
  name: __('Parts')
};
export var BUSINESS_OFFICE = {
  id: 'BUSINESS_OFFICE',
  name: __('Business Office')
};
var DEPARTMENT_TYPES = (_DEPARTMENT_TYPES = {}, _defineProperty(_DEPARTMENT_TYPES, VEHICLE_SALES.id, VEHICLE_SALES), _defineProperty(_DEPARTMENT_TYPES, SERVICE.id, SERVICE), _defineProperty(_DEPARTMENT_TYPES, PARTS.id, PARTS), _defineProperty(_DEPARTMENT_TYPES, BUSINESS_OFFICE.id, BUSINESS_OFFICE), _DEPARTMENT_TYPES);
export default DEPARTMENT_TYPES;